export default "__VITE_ASSET__BCKRaudH__"